<template>
  <div class="main-background">
    <div class="sub-header">
      <h2>استعلامات</h2>
    </div>

    <div class="custom-box mar20t">
      <div>
        <div class="mar5b">
          <ul>
            <li>
              برای استفاده هر یک از خدمات استعلام مبلغ ۵۲,۰۰۰ ريال از شارژ کیف
              پول شما کسر می گردد.
            </li>
            <li>
              اگر قبلا از خدمات استعلام استفاده کرده اید، برای مشاهده تاریخچه از
              منوی "پشتیبانی" به بخش "تاریخچه استعلامات" بروید.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom-slider">
      <div class="carousel-items">
        <router-link to="/inquiry/select-car/violation-inquiry">
          <img
            class="img-tehran-tolls"
            alt="نمایش جزئیات کامل خلافی و عکس تخلف"
            title="نمایش جزئیات کامل خلافی و عکس تخلف"
            src="../../assets/img/car-fine/11.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">نمایش جزئیات کامل خلافی و عکس تخلف</p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
      <div class="carousel-items">
        <router-link to="/inquiry/select-car/violation-inquiry-all">
          <img
            class="img-tehran-tolls"
            alt="نمایش مبلغ کل خلافی و پرداخت با تسویه آنی"
            title="نمایش مبلغ کل خلافی و پرداخت با تسویه آنی"
            src="../../assets/img/car-fine/07.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">
              نمایش مبلغ کل خلافی و پرداخت با تسویه آنی
            </p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
      <div class="carousel-items">
        <router-link to="/inquiry/license-status-inquiry">
          <img
            class="img-tehran-tolls"
            alt="آخرین وضعیت و تاریخ صدور گواهینامه"
            title="آخرین وضعیت و تاریخ صدور گواهینامه"
            src="../../assets/img/car-fine/04.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">آخرین وضعیت و تاریخ صدور گواهینامه</p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
      <div class="carousel-items">
        <router-link to="/inquiry/license-negative-point-inquiry">
          <img
            class="img-tehran-tolls"
            alt="اطلاع از نمرات منفی گواهینامه رانندگی"
            title="اطلاع از نمرات منفی گواهینامه رانندگی"
            src="../../assets/img/car-fine/10.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">اطلاع از نمرات منفی گواهینامه رانندگی</p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
      <div class="carousel-items">
        <router-link to="/inquiry/active-plak-inquiry">
          <img
            class="img-tehran-tolls"
            alt=">شماره سریال راهور، وضعیت و تاریخ فک پلاک"
            title=">شماره سریال راهور، وضعیت و تاریخ فک پلاک"
            src="../../assets/img/car-fine/06.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">
              شماره سریال راهور، وضعیت و تاریخ فک پلاک
            </p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
      <div class="carousel-items">
        <router-link to="/inquiry/select-car/card-sanad-inquiry">
          <img
            class="img-tehran-tolls"
            alt="آخرین وضعیت صدور و ارسال کارت و سند"
            title="آخرین وضعیت صدور و ارسال کارت و سند"
            src="../../assets/img/car-fine/02.png"
          />
          <div class="carousel-items-title">
            <p style="color: #002664;">آخرین وضعیت صدور و ارسال کارت و سند</p>
            <div class="carousel-items-link">مشاهده</div>
          </div>
        </router-link>
      </div>
    </div>

    <!-- <div class="carousel-items">
      <router-link to="/inquiry/select-car/-">
        <img
          class="img-tehran-tolls"
          alt="دریافت تصویر تخلف خودرو"
          title="دریافت تصویر تخلف خودرو"
          src="../../assets/img/car-fine/08.png"
        />
      </router-link>
    </div> -->
    <!-- <div class="carousel-items">
      <router-link to="/inquiry/select-car/tehran-tolls">
        <img
          class="img-tehran-tolls"
          alt="استعلام طرح ترافیک تهران"
          title="استعلام طرح ترافیک تهران"
          src="../../assets/img/tehran_tolls.png"
        />
      </router-link>
    </div>
     <div class="carousel-items">
      <router-link to="/inquiry/select-car/air-pollutions">
        <img
          class="img-tehran-tolls"
          alt="استعلام روزهای باقی مانده طرح کاهش آلودگی هوای تهران"
          title="استعلام روزهای باقی مانده طرح کاهش آلودگی هوای تهران"
          src="../../assets/img/tehran_tolls.png"
        />
      </router-link>
    </div>
    <div class="carousel-items">
      <router-link to="/inquiry/select-car/freeway-tolls">
        <img
          class="img-freeway-tolls"
          alt="استعلام عوارض آزاد راه"
          title="استعلام عوارض آزاد راه"
          src="../../assets/img/freeway_tolls.png"
        />
      </router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.home {
  padding-top: 15px;
}

.carousel-items {
  margin: 5px 12px;
}

.carousel-items img {
  width: 100%;
}
</style>
